import { Colors } from '../../../theme/colors';

const AuthenticationOuterContainerStyle = `
  background: ${Colors.neroDark};
`;

export default AuthenticationOuterContainerStyle;
